export default __webpack_public_path__ + "static/media/stack.cafa2e7a.png";